import { createContext } from "react";

export const SpecialInputContext = createContext("");